import React from "react";
import { MDBBtn, MDBCheckbox } from "mdb-react-ui-kit";

const ImageProcessingStep = ({
  formData,
  processing,
  processingImages,
  progress,
  processedImages,
  handleInputChange,
  handleStartImageEditing,
}) => {
  return (
    <div className="step-panel">
      <div className="step-header">
        <h2>Image Processing</h2>
        <p>Select enhancements to apply to your images</p>
      </div>
      <div className="image-options">
        <div className="checkbox-wrapper">
          <MDBCheckbox
            label="Background Removal"
            checked={formData.backgroundRemoval}
            onChange={(e) =>
              handleInputChange("backgroundRemoval", e.target.checked)
            }
          />
        </div>
        <div className="checkbox-wrapper">
          <MDBCheckbox
            label="Upscale Image"
            checked={formData.upscaleImage}
            onChange={(e) => handleInputChange("upscaleImage", e.target.checked)}
          />
        </div>
      </div>
      <MDBBtn
        className="mt-3"
        disabled={processing}
        onClick={handleStartImageEditing}
      >
        {processing ? "Processing..." : "Start Image Processing"}
      </MDBBtn>
      {processingImages && (
        <div className="progress-bar-wrapper mt-3">
          <div className="progress-bar-bg">
            <div
              className="progress-bar-fill"
              style={{ width: `${progress}%` }}
            />
          </div>
          <span>{progress}% Processing</span>
        </div>
      )}
      {processedImages.length > 0 && (
        <div className="processed-images mt-4">
          {processedImages.map((img, i) => (
            <img key={i} src={img} alt={`Processed ${i}`} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageProcessingStep;

